export default {"src":"/_next/static/media/search.861acbe6.svg","height":24,"width":24};